import { Controller } from "@hotwired/stimulus"

// Handles company switching (row click → POST) and alias name editing (contenteditable → PUT).
//
// Usage:
//   <div data-controller="company-switcher"
//        data-company-switcher-url-value="/en/companies/switch_company">
//     <tr data-action="click->company-switcher#switch"
//         data-company-switcher-id-param="123">
//       ...
//     </tr>
//     <span contenteditable="true"
//           data-action="input->company-switcher#updateAlias"
//           data-company-switcher-alias-url-param="/en/companies/123/...">
//       Alias
//     </span>
//   </div>

export default class extends Controller {
  static values = { url: String }

  switch(event) {
    // Don't switch if the user clicked on the editable alias cell
    if (event.target.closest("[contenteditable]")) return
    event.preventDefault()

    const companyId = event.params.id
    if (!companyId) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json"
      },
      body: `new_company_id=${companyId}`
    }).then(response => {
      if (response.ok) {
        return response.json()
      }
    }).then(data => {
      if (data?.redirect_url) {
        window.Turbo.visit(data.redirect_url)
      } else {
        window.location.reload()
      }
    })
  }

  // Debounced alias name update
  _aliasTimer = null
  updateAlias(event) {
    const el = event.target
    const url = el.dataset.aliasUrl
    const aliasName = el.textContent.trim()

    clearTimeout(this._aliasTimer)
    this._aliasTimer = setTimeout(() => {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken
        },
        body: `alias_name=${encodeURIComponent(aliasName)}`
      })
    }, 500)
  }
}
